import styled from 'styled-components';

export const StyledButton = styled.input`
  box-sizing: border-box;
  background: var(--primary);
  color: white;
  text-transform: uppercase;
  border: none;
  margin-left: 0;
  margin-right: 0;
  margin-top: 40px;
  padding: 15px;
  width: 60%;
`;

export const StyledButtonNormal = styled.button`
  box-sizing: border-box;
  background: green;
  color: white;
  text-transform: uppercase;
  border: none;
  margin: 0 0.5rem;
  margin-top: 40px;
  padding: 15px;
  width: 60%;
`;
